module.exports = __webpack_public_path__ + "img/63600.e60d4a1a.jpg";